import FrontSonda from '@gcloud-npm/utils.monitoring.front-sonda';

export const normalizeCreateCQResponse = (response, context) => {
  // Si vienen más de una promoción en cada customerQuoteItem,
  // se envía error a IC y no se devuelve ninguna al frontal
  if (response && Array.isArray(response.selectionGroups)) {
    if (response.selectionGroups.length > 1) {
      const frontSonda = new FrontSonda({
        processName: 'normalizeCreateCQResponse',
        context,
        filePath: 'adabyron/cqv2/normalizers',
      } as any);
      const warning =
        'Se está recibiendo más de un selectionGroup en el inicializarPedido';
      frontSonda.warningMessage({ info: warning });
    } else if (
      response.selectionGroups[0] &&
      Array.isArray(response.selectionGroups[0].customerQuoteItems)
    ) {
      let warning = '';
      response.selectionGroups[0].customerQuoteItems.forEach((item) => {
        if (
          item &&
          item.productOffering &&
          Array.isArray(item.productOffering.productPromotions) &&
          item.productOffering.productPromotions.length > 1
        ) {
          // Vaciamos el array y completamos el nombre del error
          warning = 'Recibimos las promociones: ';
          item.productOffering.productPromotions.forEach((elem) => {
            warning += `${elem.id},`;
          });
          warning +=
            'y no se sabe cuál aplicar, sólo debería haber una a lo máximo';
          const frontSonda = new FrontSonda({
            processName: 'normalizeCreateCQResponse',
            context,
            filePath: 'adabyron/cqv2/normalizers',
          } as any);
          frontSonda.warningMessage({ info: warning });
        }
      });
    }
  }

  return response;
};

export const normalizeGetProvisionalAgreementResponse = (
  datos: any,
): {
  agreementApplies: boolean;
  attachments: { content: any; name: string }[];
} => {
  const { precontrato, attachments: receivedAttachments } = datos;

  let agreementApplies = false;
  const attachments = [];

  if (precontrato === '1') {
    agreementApplies = true;
    if (Array.isArray(receivedAttachments)) {
      receivedAttachments.forEach((elem) => {
        attachments.push({
          content: elem.content,
          name: elem.name,
        });
      });
    }
  }

  const normalizedResponse = {
    agreementApplies,
    attachments,
  };

  return normalizedResponse;
};
